import { render } from "./EchipeSingle.vue?vue&type=template&id=7bfbf4c4&scoped=true"
import script from "./EchipeSingle.vue?vue&type=script&lang=js"
export * from "./EchipeSingle.vue?vue&type=script&lang=js"

import "./EchipeSingle.vue?vue&type=style&index=0&id=7bfbf4c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfbf4c4"]])

export default __exports__